import Classes from "./Footer.module.css";
import { Link } from "react-router-dom";
import Layout from "../../Layout/Layout.jsx";

function Terms() {
  return (
   <Layout>
  <div className={Classes.container}>
  <div className={Classes.terms}>
      <div className={Classes.termsHeader}>
        <h2>Terms and Conditions</h2>
      </div>
      <div className={Classes.termsPara}>
        <h5>Terms and Conditions of evangadi.com</h5>
        <p>
          Effective Sept 26, 2019.
          <br />
          This Terms of Use Agreement ("agreement") is entered between "you"
          (the user of this website), and EVANGADI, INC. This agreement sets the
          terms of your use of the EVANGADI INC website and services
          ("evangadi.com") that includes all subsites under evangadi.com,
          communities, messaging, and mobile apps. Access to this website and
          any use thereof, is subject to the terms and conditions set forth
          herein. In order to use this website, you must read and accept all of
          the terms and conditions of this agreement and the{" "}
          <Link
            to="/PrivacyPolicy"         
          >
            Privacy policy
          </Link>
          .
        </p>
        <h5>Acceptance of Terms.</h5>
        <p>
          By accessing, read­ing or oth­er­wise using this website, you hereby
          agree to these terms and conditions and the{" "}
          <Link
            to="/PrivacyPolicy"           
          >
            Privacy policy
          </Link>
          .
        </p>
        <h5>Terminologies</h5>
        <p>
          The following terminologies apply to these Terms and Conditions,
          Privacy Statement and Disclaimer Notice and any or all Agreements.
          "Client", "User", "You" and "Your" refers to you, the person accessing
          this website and accepting these terms and conditions. "Humans.town",
          "Evangadi.com" "Ourselves", "We" and "Us", refers to our websites
          evangadi.com and humans.town. "Party", "Parties", or "Us", refers to
          both the Client and ourselves, or either the Client or ourselves. Any
          use of the above terminology or other words in the singular, plural,
          capitalisation and/or he/she or they, are taken as interchangeable and
          therefore as referring to same.
        </p>
        <h5>Eligibility and Access</h5>
        <p>
          You represent and warrant that you are at least 13 years of age. If
          you are under age 13, you may not, under any circumstances, use this
          website. We may, at our sole discretion, refuse to offer our service
          to any person or entity and change our eligibility criteria at any
          time. You are solely responsible for ensuring that these Terms of Use
          are in compliance with all laws, rules and regulations applicable to
          you. The right to access evangadi.com is revoked where these Terms of
          Use or use of this site is prohibited or to the extent offering, sale
          or provision of evangadi.com conflicts with any applicable law, rule
          or regulation. Further, evangadi.com is offered only for your use, and
          not for the use or benefit of any third party. Without advance notice
          and at any time, we may, for violations of this agreement or for any
          other reason we choose; suspend your access to evangadi.com, suspend
          or terminate Your Account, and/or remove any of your User Content from
          evangadi.com. We reserve the right to monitor evangadi.com, and your
          use of the Service means you agree to such monitoring. At the same
          time, we do not guarantee we will monitor at all.
        </p>
        <h5>Termination</h5>
        <p>
          We may terminate your access to all or any part of evangadi.com at any
          time, with or without cause, with or without notice, effective
          immediately, which may result in the forfeiture and destruction of all
          information associated with you. All provisions of these Terms of Use
          which by their nature should survive termination shall survive
          termination, including without limitation, ownership provisions,
          warranty disclaimers, indemnity and limitations of liability.
        </p>
        <h5>Limitation of Liability</h5>
        <p>
          Evangadi.com shall not be liable for any loss of use, interruption of
          business, or any direct or indirect, special, incidental, or
          consequential damages of any kind, regardless of the form of action,
          whether in contract, tort, or otherwise, even if evangadi.com has been
          advised of the possibility of such damages, howsoever arising, out of
          use of the Service. Evangadi.com is designed and supported for
          personal use only. You may not use Evangadi.com to break the law,
          violate an individual's privacy, or infringe any person or entity’s
          intellectual property or any other proprietary rights. Evangadi.com is
          intended to be a place for your entertainment. We are not responsible
          for any decisions you make based on something you read on
          Evangadi.com.
        </p>
        <h5>Content</h5>
        <p>
          For purposes of these Terms of Use, the term "Content" includes,
          without limitation, URLs, curated URLs, content, videos, audio clips,
          written posts and comments, information, data, text, web pages,
          images, software, scripts, graphics, and interactive features
          generated, provided, or otherwise made accessible on or through
          evangadi.com.
        </p>
        <h5>User Content</h5>
        <p>
          All Content added, created, uploaded, curated, submitted, distributed,
          or posted to evangadi.com by users, whether publicly posted or
          privately transmitted (collectively "User Content"), is the sole
          responsibility of the user who originated it. You acknowledge that all
          Content accessed by you using evangadi.com is at your own risk and you
          will be solely responsible for any damage or loss to you or any other
          party resulting therefrom. <br />
          You retain the rights to your copyrighted content or information that
          you submit to evangadi.com ("user content") except as described below.
          By submitting user content to evangadi.com, you grant us a
          royalty-free, perpetual, irrevocable, non-exclusive, unrestricted,
          worldwide license to reproduce, prepare derivative works, distribute
          copies, perform, or publicly display your user content in any medium
          and for any purpose, including commercial purposes, and to authorize
          others to do so. You agree that you have the right to anything you
          post, and that your user content does not violate the copyright,
          trademark, trade secret or any other personal or proprietary right of
          any other party.Please take a look at evangadi.com{" "}
          <Link
            to="/PrivacyPolicy"            
          >
            Privacy policy
          </Link>{" "}
          for an explanation of how we may use or share information submitted by
          you or collected from you. <br />
          We take no responsibility for, we do not expressly or implicitly
          endorse, and we do not assume any liability for any user content
          submitted by you to evangadi.com. We are not responsible for the
          content or actions of any third party websites or services associated
          with posted links.
          <br /> To make evangadi.com a safe place for everyone, we need the
          following commitments from our users. You will not post unauthorized
          commercial communications (such as spam), You will not post illegal
          contents, You will not collect users' content or information, or
          otherwise access evangadi.com, using automated means (such as
          harvesting bots, robots, spiders, or scrapers) without our prior
          permission, You will not engage in unlawful multi-level marketing,
          such as a pyramid scheme, on evangadi.com, You will not upload viruses
          or other malicious code, You will not solicit login information or
          access an account belonging to someone else, You will not bully,
          intimidate, or harass any user, You will not post content that: is
          hate speech, threatening, or pornographic; incites violence; or
          contains nudity or graphic or gratuitous violence, You will not do
          anything that could disable, overburden, or impair the proper working
          or appearance of evangadi.com, such as a denial of service attack or
          interference with page rendering or other evangadi.com functionality,
          You will not post someone's personal information or post links to
          personal information, You will not facilitate or encourage any
          violations of this Statement or our policies.
        </p>
        <h5>Rights Associated with the Service</h5>
        <p>
          evangadi.com contains (or you may be sent through the Site or the
          Services) links to other websites ("Third Party Sites") as well as
          articles, photographs, text, graphics, pictures, designs, music,
          sound, video, information, software and other content belonging to or
          originating from third parties (the "Third Party Content"). Such Third
          Party Sites and Third Party Content are not investigated, monitored or
          checked for accuracy, appropriateness, or completeness by us, and we
          are not responsible for any Third Party Sites accessed through the
          Site or any Third Party Content posted on the Site, including without
          limitation the content, accuracy, offensiveness, opinions, reliability
          or policies of or contained in the Third Party Sites or the Third
          Party Content. Inclusion of or linking to any Third Party Site or any
          Third Party Content does not imply approval or endorsement thereof by
          us. If you decide to leave the Site and access the Third Party Sites,
          you do so at your own risk and you should be aware that our terms and
          policies no longer govern. You should review the applicable terms and
          policies, including privacy and data gathering practices, of any site
          to which you navigate from the Site. Users of the Service assume
          complete responsibility and risk in their use of any external sites.
        </p>
        <h5>Use of the Service</h5>
        <p>
          You may only display the content of the Service for your own personal
          non-commercial use and may not otherwise copy, reproduce, alter,
          modify, create derivative works, or publicly display any content. You
          may not use any robot, spider, other device or manual process to
          monitor or copy any content from the Service without our written
          permission. If you are uncertain whether your intended use of the
          Service is permissible, please contact us. evangadi.com shall have the
          right in its sole discretion to suspend or terminate the Service or
          your access to it.
          <br />
          evangadi.com provides the content on evangadi.com "as is" and
          evangadi.com shall not be held liable for your use of the information.
          <br />
          TO THE FULLEST EXTENT ALLOWED UNDER LAW, evangadi.com DISCLAIMS ALL
          WARRANTIES INCLUDING WARRANTIES FOR MERCHANTABILITY, NON-INFRINGEMENT
          AND FITNESS FOR A PARTICULAR PURPOSE.
        </p>
        <h5>Copyright, DMCA and takedowns</h5>
        <div>
          We will respond to legitimate requests under the Digital Millennium
          Copyright Act ("DMCA"), and we retain the right to remove user and
          curated content on evangadi.com that we deem to be infringing the
          copyright of others. If you become aware of content on evangadi.com
          that infringes your copyright rights, you may submit a properly
          formatted DMCA request (see 17 U.S.C.§ 512) to evangadi.com. <br />
          Misrepresentations of infringement can result in liability for
          monetary damages. You may want to consult an attorney before taking
          any action pursuant to the DMCA. Any DMCA request should be sent to
          this contact information:
          <br /> Copyright Agent c/o DMCA 1812 Metzerott RD #37 Adelphi, MD
          20783
          <br /> Please send our Copyright Agent the following information:
          <ol>
            <li>
              The electronic or physical signature of the owner of the copyright
              or the person authorized to act on the owner's behalf;
            </li>
            <li>
              Identification of the copyrighted work claimed to have been
              infringed, or a representative list of such works;
            </li>
            <li>
              The URL or Internet location of the materials claimed to be
              infringing or to be the subject of infringing activity, or
              information reasonably sufficient to permit us to locate the
              material;
            </li>
            <li>Your name, address, telephone number and email address;</li>
            <li>
              A statement by you that you have a good faith belief that the
              disputed use of the material is not authorized by the copyright
              owner, its agent or the law; and
            </li>
            <li>
              A statement by you, made under penalty of perjury, that the above
              information in your notice is accurate and that you are the
              copyright owner or are authorized to act on the copyright owner's
              behalf.
            </li>
          </ol>
          <p>
            If you believe User Content was wrongly removed from evangadi.com
            due to a DMCA request, you may request a copy of the DMCA notice and
            you may file a counter-notification by sending us the following:
          </p>
          <ol>
            <li>Your physical or electronic signature;</li>
            <li>
              Identification of the material that has been removed or to which
              access has been disabled and where the material was located online
              before it was removed or access to it was disabled;
            </li>
            <li>
              A statement by you, under penalty of perjury, that you have a good
              faith belief that the material was removed or disabled as a result
              of mistake or misidentification of the material to be removed or
              disabled; and
            </li>
            <li>
              Your name, address, and telephone number, and a statement that you
              consent to the jurisdiction of federal district court for the
              judicial district in which the address is located, or if your
              address is outside of the United States, for any judicial district
              in which the service provider may be found, and that you will
              accept service of process from the person who provided
              notification under DMCA 512 subsection (c)(1)(c) or an agent of
              such person.
            </li>
          </ol>
        </div>
        <h5>Disclaimers</h5>
        <p>
          THE SITE, SERVICES, EVANGADI.COM CONTENT, THIRD PARTY MATERIALS AND
          USER CONTENT ARE PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
          EITHER EXPRESS OR IMPLIED. WITHOUT LIMITING THE FOREGOING,
          EVANGADI.COM EXPLICITLY DISCLAIMS ANY WARRANTIES OF MERCHANTABILITY,
          FITNESS FOR A PARTICULAR PURPOSE, QUIET ENJOYMENT OR NON-INFRINGEMENT,
          AND ANY WARRANTIES ARISING OUT OF COURSE OF DEALING OR USAGE OF TRADE.
          EVANGADI.COM MAKES NO WARRANTY THAT THE SITE, SERVICES, EVANGADI.COM
          CONTENT, THIRD PARTY MATERIALS OR USER CONTENT WILL MEET YOUR
          REQUIREMENTS OR BE AVAILABLE ON AN UNINTERRUPTED, SECURE, OR
          ERROR-FREE BASIS.
          <br /> NO ADVICE OR INFORMATION, WHETHER ORAL OR WRITTEN, OBTAINED
          FROM EVANGADI.COM OR THROUGH THE SITE, SERVICES, EVANGADI.COM CONTENT
          OR USER CONTENT, WILL CREATE ANY WARRANTY NOT EXPRESSLY MADE HEREIN.
        </p>
        <h5>EARNINGS DISCLAIMER</h5>
        <p>
          Our programs are intended to teach and help you become a web
          developer. It takes a lot of work and discipline to become a
          professional web developer. Please don’t enroll in our programs if you
          believe that you can quickly make money by becoming a web developer.
          We only want serious people dedicated to real personal and
          professional development who want to improve their skill in the web
          development field. As stipulated by law, we cannot and do not make any
          guarantees about your ability to get results or earn any money with
          the programming skills we teach you.
          <br /> We just want to help by teaching the skills to help you join
          the coding world. You should know that all products and services by
          our company are for educational and informational purposes only.
          Nothing on this page, any of our Sites, or any of our content or
          curriculum is a promise or guarantee of results or future earnings,
          and we do not offer any legal, medical, tax or other professional
          advice. Any financial numbers referenced here, or on any of our Sites,
          are illustrative of concepts only and should not be considered average
          earnings, exact earnings, or promises for actual or future
          performance.
          <br /> Making decisions based on any information presented in our
          products, events, services, or Sites, should be done only with the
          knowledge that you could experience risk or losses just like any
          educational endeavor. Use caution and always consult your accountant,
          lawyer or professional advisor before acting on this. You alone are
          responsible and accountable for your decisions, actions and results in
          life, and by your registration here you agree not to attempt to hold
          us liable for your decisions, actions or results, at any time, under
          any circumstance.
        </p>
        <h5>Indemnity</h5>
        <p>
          You agree to defend, indemnify, and hold evangadi.com, its officers,
          directors, employees and agents, harmless from and against any claims,
          liabilities, damages, losses and expenses, including without
          limitation reasonable legal and accounting fees, arising out of or in
          any way connected with User Content, your access to or use of the
          Site, Services or evangadi.com Content, or your violation of these
          Terms of Use.
        </p>
        <h5>Governing Law and Jurisdiction</h5>
        <p>
          These Terms of Use shall be governed by and construed in accordance
          with the laws of the State of Delaware, including its conflicts of law
          rules, and the United States of America. You agree that any dispute
          arising from or relating to the subject matter of these Terms of Use
          shall be governed by the exclusive jurisdiction and venue of the state
          and federal courts of Delaware.
        </p>
        <h5>Modification</h5>
        <p>
          We reserve the right to modify this Agreement at any time, and without
          prior notice, by posting amended terms on this website. Your continued
          use of this website indicates your acceptance of the amended
          Agreement.
        </p>
      </div>
    </div>
  </div>
   </Layout>
  );
}

export default Terms;
